import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SkyLuxeTailwind from './components/SkyLuxeTailwind';
import PrivacyPolicy from './components/PrivacyPolicy';
import Disclaimer from './components/Disclaimer';
import TermsOfService from './components/TermsOfService';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Landing Page Route - Main Entry Point */}
          <Route path="/landing" element={<SkyLuxeTailwind />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* Redirect Root to Landing Page */}
          <Route path="/" element={<Navigate to="/landing" replace />} />
          
          {/* Catch-all redirect to landing page */}
          <Route path="*" element={<Navigate to="/landing" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 